"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MMOModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@chakra-ui/react");
var react_2 = require("react");
var MMODivider_1 = require("./MMODivider");
var Shimmer_1 = require("./Shimmer");
var MMOModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, _b = _a.modalZIndex, modalZIndex = _b === void 0 ? 999 : _b, children = _a.children;
    var _c = __read((0, react_2.useState)(false), 2), isVisible = _c[0], setIsVisible = _c[1];
    (0, react_2.useEffect)(function () {
        if (isOpen) {
            setTimeout(function () { return setIsVisible(true); }, 100);
        }
        else {
            setIsVisible(false);
        }
    }, [isOpen]);
    if (!isOpen) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(react_1.Box, { zIndex: modalZIndex, top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "#00000099", position: "fixed", padding: 4, display: "flex", alignItems: "center", justifyContent: "center", onClick: onClose, opacity: isVisible ? "1" : "0", transition: "all 0.3s", children: (0, jsx_runtime_1.jsxs)(react_1.Box, { width: "100%", maxWidth: "600px", backgroundColor: "#3E4355EE", padding: 2, borderRadius: 4, boxShadow: "rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px", position: "relative", onClick: function (e) { return e.stopPropagation(); }, children: [(0, jsx_runtime_1.jsx)(Shimmer_1.Shimmer, { top: 0, left: 0, position: "absolute" }), (0, jsx_runtime_1.jsx)(Shimmer_1.Shimmer, { bottom: 0, left: 0, position: "absolute" }), (0, jsx_runtime_1.jsxs)(react_1.Box, { width: "100%", height: "100%", border: "1px solid #494F5F", padding: 4, borderRadius: 4, children: [(0, jsx_runtime_1.jsx)(react_1.Box, { width: "100%", background: "linear-gradient(90deg,#c7b892 0%,#f5e9c8 46.23%,#c7b892 95%)", backgroundClip: "text", fontFamily: "Platypi", fontSize: "x-large", style: {
                                WebkitTextFillColor: "transparent",
                                WebkitBackgroundClip: "text",
                            }, textAlign: "center", fontWeight: "bold", children: title }), (0, jsx_runtime_1.jsx)(MMODivider_1.MMODivider, { color: "#494F5F" }), children] })] }) }));
};
exports.MMOModal = MMOModal;
